/**
 * Helper function to open a lead in a new tab
 * This can be imported and used anywhere in the application
 */
export const openLeadInNewTab = (leadId) => {
  window.open(`/leads/${leadId}`, '_blank');
};